import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { validateEmail } from 'utils/email'

const useAgentName = (agentId: number): string => {
  const { team = [] } = useSelector(state => (
    state.embed.configuration
  ))
  const { t } = useTranslation()

  return useMemo(() => {
    const recipient = team.find(user => user.id === agentId)
    return !!recipient && !validateEmail(recipient.name) ? recipient.name : t('agent')
  }, [team, agentId, t])
}

export default useAgentName
